<template>
  <div
    class="bg-black-transparent absolute w-full h-full backdrop-filter backdrop-blur-sm top-0 left-0 flex items-center justify-center">
    <div id="popup" class="bg-white classen__rounded h-auto px-5 pb-10 py-5"
         :class="{'step_0': step === 0, 'step_1': step === 1,}">
      <p class="text-right text-2xl" @click="$emit('cancel')"><i class="fas fa-times"></i></p>
      <p class="text-3xl text-center mx-auto mt-5" :class="{'w-1/2': step === 1}">
        {{ getTranslation(headerText) }}
      </p>

      <div v-if="step === 0" class="flex justify-center mt-10">
        <div class="flex justify-between mt-10">
          <button class="classen__button hover__button normal-case" @click="$emit('cancel')">
            {{ getTranslation('no') }}
          </button>
          <button class="classen__button hover__button ml-5 normal-case" @click="step = 1">
            {{ getTranslation('yes') }}
          </button>
        </div>
      </div>

      <div v-if="step === 1">
        <div id="step_1_body" class="relative w-8/10 mx-auto mt-10">
          <c-option-dropdown class="w-full border" :options="linkOptions"
                             :selected-option.sync="selectedLinkOption"/>
          <c-option-dropdown v-if="selectedLinkOption.value === 'linkToUser'"
                             class="w-full border mt-5"
                             :options="userOptions"
                             :selected-option.sync="selectedUser"/>

        </div>
        <div class="flex justify-center h-full">
          <button class="classen__button hover__button classen__button_active ml-5 normal-case"
                  :disabled="optionsAreInvalid"
                  :class="{'cursor-not-allowed':optionsAreInvalid}"
                  @click="sendDelete">
            {{ getTranslation('confirm') }}
          </button>
        </div>
      </div>
    </div>
    <c-loader v-if="isDeleting"/>
  </div>
</template>

<script>
import getTranslation from "../../../mixins/getTranslation";
import OptionDropdown from "../OptionDropdown";
import Loader from "../../Loader";

export default {
  name: "DeleteUserPopup",

  mixins: [getTranslation],

  components: {
    'c-option-dropdown': OptionDropdown,
    'c-loader': Loader,
  },

  props: {
    user: {required: true}
  },

  data() {
    return {
      step: 0,
      linkOptions: [
        {value: 'linkToMe', name: 'Link to me'},
        {value: 'linkToUser', name: 'Link to someone else'},
      ],
      selectedLinkOption: {value: '', name: 'Make a choice'},
      selectedUser: {value: '', name: 'Choose user'},
      isDeleting: false,
    }
  },

  created() {
    this.linkOptions = [
      {value: 'linkToMe', name: this.getTranslation('linkToMe')},
      {value: 'linkToUser', name: this.getTranslation('linkToUser')},
    ]
  },

  destroyed() {

  },

  computed: {
    userOptions() {
      return this.$dashboardStore.getters.getUsers.map((user) => {
        return {
          value: user.id,
          name: user.email
        }
      })
    },

    headerText() {
      let headerMapping = {
        0: 'areYouSureYouWantToDeleteTheFollowingUser',
        1: 'whatToDoWithUserClientSelections',
      }

      return headerMapping[this.step]
    },

    changeToId() {
      if (this.selectedLinkOption.value === 'linkToMe') {
        return this.$dashboardStore.getters.getActiveUser().id
      }

      return this.selectedUser.value
    },

    optionsAreInvalid() {
      return this.selectedLinkOption.value === '' || (this.selectedLinkOption.value === 'linkToUser' && this.selectedUser.value === '');
    }
  },

  methods: {
    sendDelete() {
      if (this.optionsAreInvalid) {
        return;
      }
      this.isDeleting = true
      this.$dashboardStore.dispatch('deleteUser', {
        userId: this.user.id,
        changeToId: this.changeToId
      })
        .then((res) => {
          this.isDeleting = false;
          if (res.code === 200) {
            this.$dashboardStore.dispatch('reloadUsers')
              .then(() => {
                this.$emit('cancel');
              })
          }
        })
        .catch((e) => {
          console.warn('something went wrong', e)
          this.isDeleting = false;
        })
    }
  },
}
</script>

<style scoped>
#popup {
  width: 944px;
}

#step_1_body {
  height: 260px;
}

#confirm {
  bottom: 0;
}

.step_0 {
  height: 311px;
}

.step_1 {
  height: 583px;
}
</style>
